<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { AppDeviceEnquire } from '@/utils/mixin'

export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      locale: zhCN
    }
  },
  mounted() {}
}
</script>
<style>
#app {
  height: 100%;
}
.tcg-acticle img {
  max-width: 100%;
}
.tcg-acticle iframe {
  max-width: 100%;
}
.mt-20 {
  margin-top: 20px !important;
}
.mr-20 {
  margin-right: 20px !important;
}
.ml-20 {
  margin-left: 20px !important;
}
.mb-20 {
  margin-bottom: 20px !important;
}
.mt-10 {
  margin-top: 10px !important;
}
.mr-10 {
  margin-right: 10px !important;
}
.ml-10 {
  margin-left: 10px !important;
}
.mb-10 {
  margin-bottom: 10px !important;
}
.m-20 {
  margin: 20px 0;
}
/* .ant-form-item{
    margin-top: 15px !important;
    margin-bottom: 15px !important
  } */
.form-title {
  background: transparent;
  padding: 24px 0;
  zoom: 1;
  min-height: 48px;
  font-size: 16px;
  color: @heading-color;
  font-weight: 500;
}
.flex-ac {
  display: flex;
  align-items: center;
}
.f18 {
  font-size: 18px;
}
.red {
  color: #f95f5f;
}
.green {
  color: #b3f95f;
}
.z-index-100000 {
  z-index: 100000;
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 8px;
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
  background   : #535353;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #7ee1ec;
  background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
  )
}
</style>
